export default __webpack_public_path__ + "static/media/f11.4d7bcb5a.jpg";